import * as z from "zod";

export const getSignupAddressFromSuggestion = {
  name: "getSignupAddressFromSuggestion" as const,
  input: z.object({
    email: z.email(),
    otpId: z.string(),
    passcode: z.string(),
    suggestionId: z.string(),
  }),
  output: z.object({
    address: z
      .object({
        address1: z.string(),
        address2: z.string().optional(),
        city: z.string(),
        province: z.string(),
        zip: z.string(),
        countryCode: z.string(),
      })
      .nullish(),
  }),
};
